var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 46,
    viewBox: "0 0 74 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3506_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1502 13.5062H74.0002V30.3805H68.1502V28.0522C65.6756 29.798 62.6599 30.8268 59.3752 30.8268C51.0491 30.8268 44.2983 24.1126 44.2983 15.8314C44.2983 7.55334 51.0475 0.839111 59.3737 0.839111C63.1087 0.839111 66.5286 2.18132 69.1846 4.4194L64.6841 8.85124C63.1548 7.7322 61.3088 7.10541 59.3737 7.10541C57.0327 7.10541 54.8286 8.00127 53.2086 9.65688C51.544 11.3125 50.5987 13.5062 50.5987 15.8345C50.5987 18.1628 51.544 20.355 53.2086 22.0122C54.8286 23.6235 57.0343 24.5637 59.3737 24.5637C61.713 24.5637 63.9187 23.6235 65.5833 22.0122C65.8984 21.6988 67.2033 20.3566 67.6091 19.3262H60.8584V13.5062H68.1502ZM68.1041 19.3246L68.1486 19.3689V19.3246H68.1041Z",
    fill: "#081B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9224 1.28705H40.9436V30.3821H33.9224V1.28705Z",
    fill: "#081B4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9421 1.28705L33.9209 6.8126V1.28705H40.9421Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3569 30.3821L21.242 26.3095H10.2152L8.10021 30.3821H0L15.7517 1.28705L31.4587 30.3821H23.3569ZM13.0511 20.8473H18.4061L15.7517 15.7443L13.0511 20.8473Z",
    fill: "#081B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3506_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 44.6349,
    fill: "white",
    transform: "translate(0 0.839111)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.b4df0f6d6aae36f6070a7c0bfe8e2ade.svg";
export { ForwardRef as ReactComponent };